import { getApiBaseUrl } from '../config/env';
import { mapPublicTestimonialsPayload } from './mapPublicTestimonials';

const CACHE_KEY = 'jobscribe_public_testimonials_v1';
const CACHE_TTL_MS = 10 * 60 * 1000;

let inflightRequest = null;

function readCache() {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.fetchedAt) return null;
    if (Date.now() - parsed.fetchedAt > CACHE_TTL_MS) return null;
    return mapPublicTestimonialsPayload(parsed);
  } catch {
    return null;
  }
}

function writeCache(payload) {
  try {
    sessionStorage.setItem(
      CACHE_KEY,
      JSON.stringify({
        fetchedAt: Date.now(),
        pricing: payload.pricingItems,
        signup: payload.signupItems,
      })
    );
  } catch {
    // ignore
  }
}

export function getCachedPublicTestimonials() {
  return readCache();
}

function hasContent({ pricingItems, signupItems }) {
  return pricingItems.length > 0 || signupItems.length > 0;
}

export async function fetchPublicTestimonials(options = {}) {
  const { forceRefresh = false } = options;

  if (!forceRefresh) {
    const cached = readCache();
    if (cached && hasContent(cached)) return cached;
  }

  if (inflightRequest) return inflightRequest;

  inflightRequest = (async () => {
    const res = await fetch(`${getApiBaseUrl()}/public/testimonials`, {
      credentials: 'omit',
    });
    if (!res.ok) {
      throw new Error('Failed to fetch testimonials');
    }
    const json = await res.json();
    const data = json.data ?? json;
    const payload = mapPublicTestimonialsPayload(data);
    if (hasContent(payload)) {
      writeCache(payload);
    }
    return payload;
  })();

  try {
    return await inflightRequest;
  } finally {
    inflightRequest = null;
  }
}

export function prefetchPublicTestimonials() {
  const cached = readCache();
  if (cached && hasContent(cached)) return;
  void fetchPublicTestimonials().catch(() => {});
}
